"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crossPollinateTransactions = exports.translateToTransaction = exports.parseTransaction = exports.validateTransaction = exports.fixTransaction = exports.transactionToDynamoDBDocClientObject = exports.dynamodbRecordToTransaction = void 0;
const constants_1 = require("./constants");
const moment_1 = require("moment");
const transaction_1 = require("./transaction");
const flow_key_1 = require("./flow-key");
const liquitics_util_1 = require("./liquitics-util");
const string_utils_1 = require("./string-utils");
function dynamodbRecordToTransaction(record) {
    const transaction = new transaction_1.Transaction();
    if (record.dynamodb) {
        const dynamodb = record.dynamodb;
        const newImage = dynamodb.NewImage;
        if (newImage) {
            transaction.flowKey = (newImage.FlowKey) ? newImage.FlowKey.S || '' : transaction.flowKey;
            transaction.eventDatetime = (newImage.EventDatetime) ? newImage.EventDatetime.S || '' : transaction.eventDatetime;
            transaction.settleDate = (newImage.SettleDate) ? newImage.SettleDate.S || '' : transaction.settleDate;
            transaction.direction = (newImage.Direction) ? newImage.Direction.S || '' : transaction.direction;
            transaction.currency = (newImage.Currency) ? newImage.Currency.S || '' : transaction.currency;
            transaction.amount = (newImage.Amount) ? parseFloat(newImage.Amount.N || '0') : transaction.amount;
            transaction.organization = (newImage.Organization) ? newImage.Organization.S || '' : transaction.organization;
            transaction.organizationLevel = (newImage.OrganizationLevel) ? newImage.OrganizationLevel.S || '' : transaction.organizationLevel;
            transaction.desk = (newImage.Desk) ? newImage.Desk.S || '' : transaction.desk;
            transaction.tradeDatetime = (newImage.TradeDatetime) ? newImage.TradeDatetime.S || '' : transaction.tradeDatetime;
            transaction.account = (newImage.Account) ? newImage.Account.S || '' : transaction.account;
            transaction.predictionEligible = (newImage.PredictionEligible) ? string_utils_1.isTrueString(newImage.PredictionEligible.S) || false : transaction.predictionEligible;
            transaction.timeSpecific = (newImage.TimeSpecific) ? string_utils_1.isTrueString(newImage.TimeSpecific.S) || false : transaction.timeSpecific;
            transaction.settleTime = (newImage.SettleTime) ? newImage.SettleTime.S || '' : transaction.settleTime;
            transaction.timeZone = (newImage.TimeZone) ? newImage.TimeZone.S || '' : transaction.timeZone;
            transaction.client = (newImage.Client) ? newImage.Client.S || '' : transaction.client;
            transaction.clientGroup = (newImage.ClientGroup) ? newImage.ClientGroup.S || '' : transaction.clientGroup;
            transaction.supplementaryRef = (newImage.SupplementaryRef) ? newImage.SupplementaryRef.S || '' : transaction.supplementaryRef;
            transaction.product = (newImage.Product) ? newImage.Product.S || '' : transaction.product;
            transaction.productType = (newImage.ProductType) ? newImage.ProductType.S || '' : transaction.productType;
            transaction.trader = (newImage.Trader) ? newImage.Trader.S || '' : transaction.trader;
            transaction.clearing = (newImage.Clearing) ? string_utils_1.isTrueString(newImage.Clearing.S) || false : transaction.clearing;
            transaction.source = (newImage.Source) ? newImage.Source.S || '' : transaction.source;
            transaction.externalId = (newImage.ExternalId) ? newImage.ExternalId.S || '' : transaction.externalId;
            transaction.secondaryId = (newImage.SecondaryId) ? newImage.SecondaryId.S || '' : transaction.secondaryId;
            transaction.flowScope = (newImage.FlowScope) ? parseFloat(newImage.FlowScope.N || '0') : transaction.flowScope;
            transaction.flowType = (newImage.FlowType) ? newImage.FlowType.S || '' : transaction.flowType;
            transaction.timeStamp = (newImage.TimeStamp) ? newImage.TimeStamp.S || '' : transaction.timeStamp;
            transaction.clientSpecificInfo = (newImage.ClientSpecificInfo) ? newImage.ClientSpecificInfo.S || '' : transaction.clientSpecificInfo;
            transaction.orderingCustomer = (newImage.OrderingCustomer) ? newImage.OrderingCustomer.S || '' : transaction.orderingCustomer;
            transaction.orderingInstitution = (newImage.OrderingInstitution) ? newImage.OrderingInstitution.S || '' : transaction.orderingInstitution;
            transaction.sendersCorrespondent = (newImage.SendersCorrespondent) ? newImage.SendersCorrespondent.S || '' : transaction.sendersCorrespondent;
            transaction.receiversCorrespondent = (newImage.ReceiversCorrespondent) ? newImage.ReceiversCorrespondent.S || '' : transaction.receiversCorrespondent;
            transaction.thirdReimbursementInstitution = (newImage.ThirdReimbursementInstitution) ? newImage.ThirdReimbursementInstitution.S || '' : transaction.thirdReimbursementInstitution;
            transaction.intermediaryInstitution = (newImage.IntermediaryInstitution) ? newImage.IntermediaryInstitution.S || '' : transaction.intermediaryInstitution;
            transaction.accountWithInstitution = (newImage.AccountWithInstitution) ? newImage.AccountWithInstitution.S || '' : transaction.accountWithInstitution;
            transaction.beneficiaryCustomer = (newImage.BeneficiaryCustomer) ? newImage.BeneficiaryCustomer.S || '' : transaction.beneficiaryCustomer;
            transaction.beneficiaryInstitution = (newImage.BeneficiaryInstitution) ? newImage.BeneficiaryInstitution.S || '' : transaction.beneficiaryInstitution;
            transaction.creditLine = (newImage.CreditLine) ? newImage.CreditLine.S || '' : transaction.creditLine;
            transaction.payClientAccount = (newImage.PayClientAccount) ? newImage.PayClientAccount.S || '' : transaction.payClientAccount;
            transaction.recClientAccount = (newImage.RecClientAccount) ? newImage.RecClientAccount.S || '' : transaction.recClientAccount;
            transaction.fxCcyPair = (newImage.FxCcyPair) ? newImage.FxCcyPair.S || '' : transaction.fxCcyPair;
            transaction.fxFxRate = (newImage.FxFxRate) ? parseFloat(newImage.FxFxRate.N || '0') : transaction.fxFxRate;
            transaction.fxExecutionSystem = (newImage.FxExecutionSystem) ? newImage.FxExecutionSystem.S || '' : transaction.fxExecutionSystem;
            transaction.fxBuySell = (newImage.FxBuySell) ? newImage.FxBuySell.S || '' : transaction.fxBuySell;
            transaction.fxTenor = (newImage.FxTenor) ? newImage.FxTenor.S || '' : transaction.fxTenor;
            transaction.mmRate = (newImage.MmRate) ? parseFloat(newImage.MmRate.N || '0') : transaction.mmRate;
            transaction.mmRateIndex = (newImage.MmRateIndex) ? newImage.MmRateIndex.S || '' : transaction.mmRateIndex;
            transaction.mmSpread = (newImage.MmSpread) ? parseFloat(newImage.MmSpread.N || '0') : transaction.mmSpread;
            transaction.mmMaturityDate = (newImage.MmMaturityDate) ? newImage.MmMaturityDate.S || '' : transaction.mmMaturityDate;
            transaction.mmSettleDate = (newImage.MmSettleDate) ? newImage.MmSettleDate.S || '' : transaction.mmSettleDate;
            transaction.mmLoanDepo = (newImage.MmLoanDepo) ? newImage.MmLoanDepo.S || '' : transaction.mmLoanDepo;
            transaction.bondIsin = (newImage.BondIsin) ? newImage.BondIsin.S || '' : transaction.bondIsin;
            transaction.bondPrice = (newImage.BondPrice) ? parseFloat(newImage.BondPrice.N || '0') : transaction.bondPrice;
            transaction.bondBuySell = (newImage.BondBuySell) ? newImage.BondBuySell.S || '' : transaction.bondBuySell;
            transaction.bondOutstandingPrincipal = (newImage.BondOutstandingPrincipal) ? parseFloat(newImage.BondOutstandingPrincipal.N || '0') : transaction.bondOutstandingPrincipal;
            transaction.repoRate = (newImage.RepoRate) ? parseFloat(newImage.RepoRate.N || '0') : transaction.repoRate;
            transaction.repoMaturityDate = (newImage.RepoMaturityDate) ? newImage.RepoMaturityDate.S || '' : transaction.repoMaturityDate;
            transaction.repoSettleDate = (newImage.RepoSettleDate) ? newImage.RepoSettleDate.S || '' : transaction.repoSettleDate;
            transaction.repoSecurity = (newImage.RepoSecurity) ? newImage.RepoSecurity.S || '' : transaction.repoSecurity;
            transaction.repoRepoReverse = (newImage.RepoRepoReverse) ? newImage.RepoRepoReverse.S || '' : transaction.repoRepoReverse;
            transaction.paymentPurpose = (newImage.PaymentPurpose) ? newImage.PaymentPurpose.S || '' : transaction.paymentPurpose;
            transaction.exportBillCommodity = (newImage.ExportBillCommodity) ? newImage.ExportBillCommodity.S || '' : transaction.exportBillCommodity;
            transaction.exportBillBillDate = (newImage.ExportBillBillDate) ? newImage.ExportBillBillDate.S || '' : transaction.exportBillBillDate;
            transaction.exportBillImporter = (newImage.ExportBillImporter) ? newImage.ExportBillImporter.S || '' : transaction.exportBillImporter;
            transaction.exportBillImporterBank = (newImage.ExportBillImporterBank) ? newImage.ExportBillImporterBank.S || '' : transaction.exportBillImporterBank;
            transaction.exportBillSettleDate = (newImage.ExportBillSettleDate) ? newImage.ExportBillSettleDate.S || '' : transaction.exportBillSettleDate;
            transaction.importBillCommodity = (newImage.ImportBillCommodity) ? newImage.ImportBillCommodity.S || '' : transaction.importBillCommodity;
            transaction.importBillBillDate = (newImage.ImportBillBillDate) ? newImage.ImportBillBillDate.S || '' : transaction.importBillBillDate;
            transaction.importBillExporter = (newImage.ImportBillExporter) ? newImage.ImportBillExporter.S || '' : transaction.importBillExporter;
            transaction.importBillExporterBank = (newImage.ImportBillExporterBank) ? newImage.ImportBillExporterBank.S || '' : transaction.importBillExporterBank;
            transaction.importBillSettleDate = (newImage.ImportBillSettleDate) ? newImage.ImportBillSettleDate.S || '' : transaction.importBillSettleDate;
            transaction.exportLcImporter = (newImage.ExportLcImporter) ? newImage.ExportLcImporter.S || '' : transaction.exportLcImporter;
            transaction.exportLcImporterBank = (newImage.ExportLcImporterBank) ? newImage.ExportLcImporterBank.S || '' : transaction.exportLcImporterBank;
            transaction.exportLcLcConditions = (newImage.ExportLcLcConditions) ? newImage.ExportLcLcConditions.S || '' : transaction.exportLcLcConditions;
            transaction.exportLcTenor = (newImage.ExportLcTenor) ? newImage.ExportLcTenor.S || '' : transaction.exportLcTenor;
            transaction.importLcExporter = (newImage.ImportLcExporter) ? newImage.ImportLcExporter.S || '' : transaction.importLcExporter;
            transaction.importLcExporterBank = (newImage.ImportLcExporterBank) ? newImage.ImportLcExporterBank.S || '' : transaction.importLcExporterBank;
            transaction.importLcLcConditions = (newImage.ImportLcLcConditions) ? newImage.ImportLcLcConditions.S || '' : transaction.importLcLcConditions;
            transaction.importLcTenor = (newImage.ImportLcTenor) ? newImage.ImportLcTenor.S || '' : transaction.importLcTenor;
            transaction.loanProduct = (newImage.LoanProduct) ? newImage.LoanProduct.S || '' : transaction.loanProduct;
            transaction.loanRate = (newImage.LoanRate) ? parseFloat(newImage.LoanRate.N || '0') : transaction.loanRate;
            transaction.loanRateIndex = (newImage.LoanRateIndex) ? newImage.LoanRateIndex.S || '' : transaction.loanRateIndex;
            transaction.loanSpread = (newImage.LoanSpread) ? parseFloat(newImage.LoanSpread.N || '0') : transaction.loanSpread;
            transaction.loanMaturityDate = (newImage.LoanMaturityDate) ? newImage.LoanMaturityDate.S || '' : transaction.loanMaturityDate;
            transaction.loanSettleDate = (newImage.LoanSettleDate) ? newImage.LoanSettleDate.S || '' : transaction.loanSettleDate;
            transaction.loanOutstandingPrincipal = (newImage.LoanOutstandingPrincipal) ? parseFloat(newImage.LoanOutstandingPrincipal.N || '0') : transaction.loanOutstandingPrincipal;
            transaction.depositProduct = (newImage.DepositProduct) ? newImage.DepositProduct.S || '' : transaction.depositProduct;
            transaction.depositRate = (newImage.DepositRate) ? parseFloat(newImage.DepositRate.N || '0') : transaction.depositRate;
            transaction.depositMaturityDate = (newImage.DepositMaturityDate) ? newImage.DepositMaturityDate.S || '' : transaction.depositMaturityDate;
            transaction.depositSettleDate = (newImage.DepositSettleDate) ? newImage.DepositSettleDate.S || '' : transaction.depositSettleDate;
        }
    }
    return transaction;
}
exports.dynamodbRecordToTransaction = dynamodbRecordToTransaction;
// ------ End   of Schemer Auto Generated Code Block (DynamoDB to Typescript Converter) ------ //
function transactionToDynamoDBDocClientObject(transaction) {
    const items = {};
    const transactionAny = transaction;
    for (let key of Object.keys(transactionAny)) {
        const dbKey = key.charAt(0).toUpperCase() + key.substring(1);
        const value = transactionAny[key];
        if (typeof value === 'boolean') {
            items[dbKey] = String(transactionAny[key]);
        }
        else if (typeof value === 'number') {
            items[dbKey] = transactionAny[key];
        }
        else if (typeof value === 'string') {
            if (value.length > 0) {
                // Let's not fill up DynamoDB with empty strings...
                items[dbKey] = transactionAny[key];
            }
        }
        else {
            console.log("Other type:" + key + " value:" + value);
        }
    }
    ;
    return items;
}
exports.transactionToDynamoDBDocClientObject = transactionToDynamoDBDocClientObject;
function fixTransaction(transaction) {
    if (transaction.currency) {
        transaction.currency = transaction.currency.toUpperCase();
    }
    if (transaction.direction) {
        transaction.direction = transaction.direction.toUpperCase();
    }
    if (transaction.productType) {
        transaction.productType = transaction.productType.toUpperCase();
    }
    const flowScope = transaction.flowScope;
    const isTrading = liquitics_util_1.isInFlowScope(flowScope, constants_1.FlowScopeBits.TRADING);
    const isSDI = liquitics_util_1.isInFlowScope(flowScope, constants_1.FlowScopeBits.SDI);
    const isPayment = liquitics_util_1.isInFlowScope(flowScope, constants_1.FlowScopeBits.PAYMENT);
    const isConfirm = liquitics_util_1.isInFlowScope(flowScope, constants_1.FlowScopeBits.CONFIRM);
    if (!transaction.product) {
        if ((!isTrading && !isSDI) && (isPayment || isConfirm)) {
            transaction.product = constants_1.UNKNOWN_VALUE;
            transaction.productType = constants_1.UNKNOWN_VALUE;
        }
    }
    if (!transaction.organizationLevel) {
        if ((!isTrading && !isSDI) && (isPayment || isConfirm)) {
            transaction.organizationLevel = constants_1.UNKNOWN_VALUE;
            transaction.desk = constants_1.UNKNOWN_VALUE;
        }
    }
    return transaction;
}
exports.fixTransaction = fixTransaction;
function validateTransaction(transaction) {
    const dateRegex = /^\d{4}\-(0?[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;
    const datetimeRegex = /^\d{4}\-(0?[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])[\sT]([012])([0-9]):([012345])([0-9]).*$/;
    if (!transaction.flowKey) {
        return 'flowKey is required';
    }
    if (!transaction.eventDatetime) {
        return 'eventDatetime is required';
    }
    // if (typeof transaction.eventDatetime !== 'undefined' && !(datetimeRegex.test(transaction.eventDatetime))) {
    //     return 'eventDatetime must be formatted starting with YYYY-MM-DD HH:mm:SS';
    // }
    if (!transaction.settleDate) {
        return 'settleDate is required';
    }
    if (typeof transaction.settleDate !== 'undefined' && !(dateRegex.test(transaction.settleDate))) {
        return 'settleDate must be formatted YYYY-MM-DD';
    }
    if (!transaction.direction) {
        return 'direction is required';
    }
    if (!transaction.currency) {
        return 'currency is required';
    }
    if (!transaction.amount) {
        return 'amount is required';
    }
    if (typeof transaction.amount !== 'undefined' && typeof transaction.amount !== 'number') {
        return 'amount must be a number';
    }
    if (!transaction.organization) {
        return 'organization is required';
    }
    if (!transaction.organizationLevel) {
        return 'organizationLevel is required';
    }
    if (!transaction.desk) {
        return 'desk is required';
    }
    if (typeof transaction.tradeDatetime !== 'undefined' && !(datetimeRegex.test(transaction.tradeDatetime))) {
        return 'tradeDatetime must be formatted starting with YYYY-MM-DD HH:mm:SS';
    }
    if (!transaction.client) {
        return 'client is required';
    }
    if (!transaction.clientGroup) {
        return 'clientGroup is required';
    }
    if (!transaction.product) {
        return 'product is required';
    }
    if (!transaction.productType) {
        return 'productType is required';
    }
    if (!transaction.source) {
        return 'source is required';
    }
    if (!transaction.externalId) {
        return 'externalId is required';
    }
    if (!transaction.flowType) {
        return 'flowType is required';
    }
    if (typeof transaction.timeStamp !== 'undefined' && !(datetimeRegex.test(transaction.timeStamp))) {
        return 'timeStamp must be formatted starting with YYYY-MM-DD HH:mm:SS';
    }
    if (typeof transaction.fxFxRate !== 'undefined' && typeof transaction.fxFxRate !== 'number') {
        return 'fxFxRate must be a number';
    }
    if (typeof transaction.mmRate !== 'undefined' && typeof transaction.mmRate !== 'number') {
        return 'mmRate must be a number';
    }
    if (typeof transaction.mmSpread !== 'undefined' && typeof transaction.mmSpread !== 'number') {
        return 'mmSpread must be a number';
    }
    if (typeof transaction.mmMaturityDate !== 'undefined' && !(dateRegex.test(transaction.mmMaturityDate))) {
        return 'mmMaturityDate must be formatted YYYY-MM-DD';
    }
    if (typeof transaction.mmSettleDate !== 'undefined' && !(dateRegex.test(transaction.mmSettleDate))) {
        return 'mmSettleDate must be formatted YYYY-MM-DD';
    }
    if (typeof transaction.bondPrice !== 'undefined' && typeof transaction.bondPrice !== 'number') {
        return 'bondPrice must be a number';
    }
    if (typeof transaction.bondOutstandingPrincipal !== 'undefined' && typeof transaction.bondOutstandingPrincipal !== 'number') {
        return 'bondOutstandingPrincipal must be a number';
    }
    if (typeof transaction.repoRate !== 'undefined' && typeof transaction.repoRate !== 'number') {
        return 'repoRate must be a number';
    }
    if (typeof transaction.repoMaturityDate !== 'undefined' && !(dateRegex.test(transaction.repoMaturityDate))) {
        return 'repoMaturityDate must be formatted YYYY-MM-DD';
    }
    if (typeof transaction.repoSettleDate !== 'undefined' && !(dateRegex.test(transaction.repoSettleDate))) {
        return 'repoSettleDate must be formatted YYYY-MM-DD';
    }
    if (typeof transaction.exportBillBillDate !== 'undefined' && !(dateRegex.test(transaction.exportBillBillDate))) {
        return 'exportBillBillDate must be formatted YYYY-MM-DD';
    }
    if (typeof transaction.exportBillSettleDate !== 'undefined' && !(dateRegex.test(transaction.exportBillSettleDate))) {
        return 'exportBillSettleDate must be formatted YYYY-MM-DD';
    }
    if (typeof transaction.importBillSettleDate !== 'undefined' && !(dateRegex.test(transaction.importBillSettleDate))) {
        return 'importBillSettleDate must be formatted YYYY-MM-DD';
    }
    if (typeof transaction.loanRate !== 'undefined' && typeof transaction.loanRate !== 'number') {
        return 'loanRate must be a number';
    }
    if (typeof transaction.loanSpread !== 'undefined' && typeof transaction.loanSpread !== 'number') {
        return 'loanSpread must be a number';
    }
    if (typeof transaction.loanMaturityDate !== 'undefined' && !(dateRegex.test(transaction.loanMaturityDate))) {
        return 'loanMaturityDate must be formatted YYYY-MM-DD';
    }
    if (typeof transaction.loanSettleDate !== 'undefined' && !(dateRegex.test(transaction.loanSettleDate))) {
        return 'loanSettleDate must be formatted YYYY-MM-DD';
    }
    if (typeof transaction.loanOutstandingPrincipal !== 'undefined' && typeof transaction.loanOutstandingPrincipal !== 'number') {
        return 'loanOutstandingPrincipal must be a number';
    }
    if (typeof transaction.depositRate !== 'undefined' && typeof transaction.depositRate !== 'number') {
        return 'depositRate must be a number';
    }
    if (typeof transaction.depositMaturityDate !== 'undefined' && !(dateRegex.test(transaction.depositMaturityDate))) {
        return 'depositMaturityDate must be formatted YYYY-MM-DD';
    }
    if (typeof transaction.depositSettleDate !== 'undefined' && !(dateRegex.test(transaction.depositSettleDate))) {
        return 'depositSettleDate must be formatted YYYY-MM-DD';
    }
    return true;
}
exports.validateTransaction = validateTransaction;
function parseTransaction(transaction) {
    if (transaction['amount']) {
        transaction['amount'] = parseFloat(transaction['amount']);
    }
    if (transaction['predictionEligible'] && typeof transaction['predictionEligible'] === 'string') {
        transaction['predictionEligible'] = string_utils_1.isTrueString(transaction['predictionEligible']) ? true : false;
    }
    if (transaction['timeSpecific'] && typeof transaction['timeSpecific'] === 'string') {
        transaction['timeSpecific'] = string_utils_1.isTrueString(transaction['timeSpecific']) ? true : false;
    }
    if (transaction['clearing'] && typeof transaction['clearing'] === 'string') {
        transaction['clearing'] = string_utils_1.isTrueString(transaction['clearing']) ? true : false;
    }
    if (transaction['flowScope']) {
        transaction['flowScope'] = parseFloat(transaction['flowScope']);
    }
    if (transaction['fxFxRate']) {
        transaction['fxFxRate'] = parseFloat(transaction['fxFxRate']);
    }
    if (transaction['mmRate']) {
        transaction['mmRate'] = parseFloat(transaction['mmRate']);
    }
    if (transaction['mmSpread']) {
        transaction['mmSpread'] = parseFloat(transaction['mmSpread']);
    }
    if (transaction['bondPrice']) {
        transaction['bondPrice'] = parseFloat(transaction['bondPrice']);
    }
    if (transaction['bondOutstandingPrincipal']) {
        transaction['bondOutstandingPrincipal'] = parseFloat(transaction['bondOutstandingPrincipal']);
    }
    if (transaction['repoRate']) {
        transaction['repoRate'] = parseFloat(transaction['repoRate']);
    }
    if (transaction['loanRate']) {
        transaction['loanRate'] = parseFloat(transaction['loanRate']);
    }
    if (transaction['loanSpread']) {
        transaction['loanSpread'] = parseFloat(transaction['loanSpread']);
    }
    if (transaction['loanOutstandingPrincipal']) {
        transaction['loanOutstandingPrincipal'] = parseFloat(transaction['loanOutstandingPrincipal']);
    }
    if (transaction['depositRate']) {
        transaction['depositRate'] = parseFloat(transaction['depositRate']);
    }
    return transaction;
}
exports.parseTransaction = parseTransaction;
function translateToTransaction(mappings, rawRow) {
    const transaction = new transaction_1.Transaction();
    const transactionAny = transaction;
    mappings.forEach((mapping) => {
        let value = rawRow[mapping.sourceField];
        if (!value && mapping.defaultValue) {
            value = mapping.defaultValue;
        }
        if (value) {
            if (mapping.remap) {
                value = mapping.remap[value];
            }
            if (mapping.mask) {
                if (mapping.transactionField.endsWith('Datetime')) {
                    value = flow_key_1.generateEventDatetime(moment_1.utc(value, mapping.mask));
                }
                else if (mapping.transactionField.endsWith('Date')) {
                    value = moment_1.utc(value, mapping.mask).format('YYYY-MM-DD');
                }
            }
            if (mapping.transactionField === 'amount') {
                value = parseFloat(value).toFixed(2);
            }
            transactionAny[mapping.transactionField] = value;
        }
    });
    mappings.forEach((mapping) => {
        if (mapping.dataType === 'DIRECTION_SIGNED' && mapping.transactionField === 'amount') {
            if (transaction.direction === 'PAY') {
                transaction.amount = -(Math.abs(transaction.amount));
            }
            else {
                transaction.amount = (Math.abs(transaction.amount));
            }
        }
    });
    transaction.eventDatetime = flow_key_1.generateEventDatetime(moment_1.utc(transaction.settleDate));
    return transaction;
}
exports.translateToTransaction = translateToTransaction;
function crossPollinateTransactions(source, target) {
    const tFlowScope = target.flowScope;
    const tIsTrading = liquitics_util_1.isInFlowScope(tFlowScope, constants_1.FlowScopeBits.TRADING);
    const tIsSDI = liquitics_util_1.isInFlowScope(tFlowScope, constants_1.FlowScopeBits.SDI);
    const tIsPayment = liquitics_util_1.isInFlowScope(tFlowScope, constants_1.FlowScopeBits.PAYMENT);
    const tIsConfirm = liquitics_util_1.isInFlowScope(tFlowScope, constants_1.FlowScopeBits.CONFIRM);
    if (tIsPayment || tIsConfirm) {
        if (liquitics_util_1.isValueMissing(target.product)) {
            target.product = source.product;
        }
        if (liquitics_util_1.isValueMissing(target.productType)) {
            target.productType = source.productType;
        }
        if (liquitics_util_1.isValueMissing(target.organizationLevel)) {
            target.organizationLevel = source.organizationLevel;
        }
        if (liquitics_util_1.isValueMissing(target.desk)) {
            target.desk = source.desk;
        }
        if (liquitics_util_1.isValueMissing(target.account)) {
            target.account = source.account;
        }
    }
}
exports.crossPollinateTransactions = crossPollinateTransactions;
//# sourceMappingURL=transaction-converter.js.map